import { integrationOptionProvider } from "@p0security/integrations-installer";

import { ClearCacheButton } from "../ClearCacheButton.tsx";
import type { SplunkStackIntegrationInstaller } from "../types.ts";

export const splunkStackResourceInstaller: SplunkStackIntegrationInstaller["components"]["iam-write"] =
  {
    items: {
      service: {
        options: {
          azure: {
            items: {
              service: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    component: "function-caller",
                    integration: "azure",
                    keyPrefix: "azure",
                  },
                ]),
              },
            },
          },
          aws: {
            items: {
              lambda: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    component: "function-caller",
                    integration: "aws",
                    keyPrefix: "aws",
                  },
                ]),
              },
            },
          },
          gcp: {
            items: {
              cloudRun: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    component: "function-caller",
                    integration: "gcloud",
                    keyPrefix: "gcp",
                  },
                ]),
              },
            },
          },
        },
      },
    },
    prerequisiteMessages: async (context) => {
      const provider = integrationOptionProvider("iam-write", [
        {
          component: "function-caller",
          integration: "aws",
          keyPrefix: "aws",
        },
        {
          component: "function-caller",
          integration: "gcloud",
          keyPrefix: "gcp",
        },
      ]);
      const options = await provider(context);
      if (!options.length)
        return (
          <div>
            Requires installed &quot;AWS or GCP Function Caller&quot; component
          </div>
        );
    },
    submitActions: (_context, _id, item) => (
      <ClearCacheButton state={item.state} />
    ),
  };
